import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { LoyaltyPointsStatus as LoyaltyPointsStatusUI } from "@jti/loyalty/components/LoyaltyPointsStatus";

import type { loyaltyPointsStatusInputs } from "./LoyaltyPointsStatus.builder";

export type LoyaltyPointsStatusProps = BuilderComponentProps<typeof loyaltyPointsStatusInputs>;

const normalizeTierName = (tierName: string): string => tierName.trim().toLowerCase();

export const LoyaltyPointsStatus: FC<LoyaltyPointsStatusProps> = ({
  pointsHistoryLabel,
  pointsHistoryUrl,
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryCtaButtonLabel,
  secondaryCtaButtonUrl,
  tiers = [],
  hideBottomSection,
}) => {
  const tiersRecord = tiers.reduce<Record<string, string>>((acc, tier) => {
    const tierName = normalizeTierName(tier.tierName);

    if (tierName && tier.tierCardImage) {
      acc[tierName] = tier.tierCardImage;
    }

    return acc;
  }, {});

  return (
    <LoyaltyPointsStatusUI
      pointsHistoryLabel={pointsHistoryLabel}
      pointsHistoryUrl={pointsHistoryUrl}
      tiers={tiersRecord}
      ctaButtonLabel={ctaButtonLabel}
      ctaButtonUrl={ctaButtonUrl}
      secondaryCtaButtonLabel={secondaryCtaButtonLabel}
      secondaryCtaButtonUrl={secondaryCtaButtonUrl}
      isInEditor={isEditing()}
      hideBottomSection={hideBottomSection}
    />
  );
};
